(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (this.hasAttribute('data-menu-only-sticky')) {
        this.initMenuOnlySticky();
        return;
      }
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    initMenuOnlySticky() {
      this.header.classList.add('gbh-menu-only-sticky');
      this.mobileLogo = this.querySelector('.header__heading-link');
      this.paintMobileLogo = () => {
        this.logoFrame = null;
        if (!this.mobileLogo || !this.logoMotion) return;
        const progress = Math.min(1, Math.max(0, -this.header.getBoundingClientRect().top / this.logoMotion.offset));
        const p = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? (progress >= 0.99 ? 1 : 0) : progress;
        this.mobileLogo.style.transform = `translate(${this.logoMotion.x * p}px, ${this.logoMotion.y * p}px) scale(${1 + (this.logoMotion.scale - 1) * p})`;
      };
      const update = () => {
        const desktop = window.matchMedia('(min-width: 990px)').matches;
        const row = this.querySelector(desktop ? '.growber-home-menu' : 'header-drawer');
        if (!row) return;
        const offset = Math.max(0, row.getBoundingClientRect().top - this.header.getBoundingClientRect().top - 12);
        this.header.style.setProperty('--gbh-logo-scroll-offset', `${offset}px`);
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight - offset}px`);
        if (this.mobileLogo) {
          this.mobileLogo.style.transform = '';
          this.logoMotion = null;
          if (!desktop) {
            const logo = this.mobileLogo.getBoundingClientRect();
            const menu = row.getBoundingClientRect();
            const icons = this.querySelector('.header__icons').getBoundingClientRect();
            this.logoMotion = {
              offset: Math.max(1, offset),
              x: (menu.right + icons.left) / 2 - (logo.left + logo.width / 2),
              y: menu.top + menu.height / 2 - (logo.top + logo.height / 2),
              scale: Math.min(110, Math.max(60, icons.left - menu.right - 16)) / logo.width
            };
            this.paintMobileLogo();
          }
        }
      };
      this.mobileLogoScroll = () => {
        if (!this.logoFrame) this.logoFrame = requestAnimationFrame(this.paintMobileLogo);
      };
      window.addEventListener('scroll', this.mobileLogoScroll, { passive: true });
      this.menuResizeObserver = new ResizeObserver(update);
      this.menuResizeObserver.observe(this.header);
      this.menuResizeObserver.observe(this.querySelector('.header'));
      this.menuFrame = requestAnimationFrame(update);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.menuResizeObserver) {
        this.menuResizeObserver.disconnect();
        cancelAnimationFrame(this.menuFrame);
        cancelAnimationFrame(this.logoFrame);
        window.removeEventListener('scroll', this.mobileLogoScroll);
        return;
      }
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
